// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"550":"80eb7938546e80d1","926":"83269c7a6b751aea"}[chunkId] + ".js";
};